module.exports = __webpack_public_path__ + "static/media/IMG_1558.975990ff.jpg";